module.exports = __webpack_public_path__ + "static/media/travel_insurance.b840c488.png";